import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 55 55"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M27.5 5.156A22.344 22.344 0 1 0 49.844 27.5 22.37 22.37 0 0 0 27.5 5.156m-1.719 12.032a1.718 1.718 0 1 1 3.438 0v12.03a1.719 1.719 0 1 1-3.438 0zM27.5 39.53a2.579 2.579 0 1 1 0-5.157 2.579 2.579 0 0 1 0 5.157"
    }, null, -1)
  ])))
}
export default { render: render }